import React from 'react';
import PropTypes from 'prop-types';

import UserProfile from 'components/UserProfile';
import Breadcrumbs from 'components/Breadcrumbs';
import Link from 'data/Link';
import Header from './Header';
import Actions from './Actions';
import Title from './Title';

const AppHeader = ({ IconComponent, title, links, children, ...props }) => (
  <Header {...props}>
    { IconComponent && IconComponent() }
    { title && <Title>{title}</Title> }
    { links && <Breadcrumbs links={links} /> }
    <Actions>{ children }</Actions>
    <UserProfile />
  </Header>
);

AppHeader.propTypes = {
  IconComponent: PropTypes.func,
  title: PropTypes.node,
  links: PropTypes.arrayOf(PropTypes.instanceOf(Link)),
  children: PropTypes.any,
};

export default AppHeader;
